import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './EcoRebates.css';
import actions from '../../actions/EcoRebatesAction';
import { initProductOptions } from '../../selectors/ProductOptionsSelector';
import { selectRebateInfoBySource } from '../../selectors/PdpNameSpaceSelector';

const cx = classNames.bind(styles);

export class EcoRebatesModal extends Component {
    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        rebateInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        filteredItems: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        deliveryZipcode: PropTypes.number,
        uiContext: PropTypes.string.isRequired,
        fromMiniPDP: PropTypes.bool,
    };

    static defaultProps = {
        actions: {},
        rebateInfo: {},
        filteredItems: [],
        deliveryZipcode: null,
        fromMiniPDP: false,
    };

    constructor() {
        super();
        this.itemsWithRebates = [];
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.filteredItems !== this.props.filteredItems ||
            nextProps.deliveryZipcode !== this.props.deliveryZipcode
        ) {
            const { filteredItems } = nextProps;
            this.itemsWithRebates = [];
            filteredItems.forEach((item) => {
                if (item.rebatesAvailable) {
                    this.itemsWithRebates.push(item.id);
                }
            });
        }
    }

    render() {
        const { rebateInfo } = this.props;
        const rebateWidgetUrl = `https://jcpenney.ecorebates.com/ui/widgets/jcpenney/rebatedetails.html?ecr_skus=${this.itemsWithRebates[0]}&ecr_uiContext=${this.props.uiContext}&ecr_zip=${this.props.deliveryZipcode}`;
        const rebatesMarkup = `<style>
            er-container {position: relative; margin-top: 20px; padding: 90% 45%; height: 0; overflow: auto;}
            .er-container iframe {position: absolute; top:0; left: 0;
              width: 100%; height: 100%; margin-top: 0px; padding: 0;}
          </style><div class="er-container"><iframe src=${rebateWidgetUrl}
            align="middle" frameborder="0"height="700" width="360" class="er-iframe">
            Content is not supported on this device</iframe></div>`;
        return (
            // eslint-disable-block
            <ModalBox
                showModal={!!rebateInfo.openModal}
                onClose={() => this.props.actions.closeEcoRebatesModal(this.props.fromMiniPDP)}
                automationId="ecorebates-modal"
                modalTheme={`${cx(styles.rebateModalBlock)} ${dt([
                    'h-[90%]',
                    'mdOnly:w-[644px]',
                    'mdOnly:max-w-[644px]',
                ])}`}
                modalBlockTheme={cx(styles.blockTheme)}
                modalOverlayTheme={`${cx(styles.rebateModalOverlay)} ${dt(['sm:!z-[120]'])}`}
            >
                {/* eslint-disable react/no-danger */}
                <div
                    className={`${cx(styles.holder)} ${dt([
                        'absolute',
                        'left-[5%]',
                        'top-[50px]',
                        'w-[89%]',
                        'h-[85%]',
                    ])}`}
                    dangerouslySetInnerHTML={{ __html: rebatesMarkup }}
                />
            </ModalBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    rebateInfo: selectRebateInfoBySource(ownProps.fromMiniPDP)(state),
    deliveryZipcode: state.deliveryZipcode,
    filteredItems: initProductOptions(ownProps.fromMiniPDP)(state).filteredItems,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EcoRebatesModal);
